export const DEFAULT_TENANTS_NAME_SEPARATOR = ', ';

export const NAME_SOURCE = {
  STAIRWELL: 'stairwell',
  CONTRACT: 'contract',
};

export const NAME_FORMAT = {
  F_LAST: 'f_last',
  FIRST_LAST: 'first_last',
  L_FIRST: 'l_first',
};

export const RENTAL_STATUS = {
  ALL: 'all',
  VACANT: 'vacant',
  RENTED: 'rented',
};

export const FLOOR_NAME_TYPES = {
  VANING: 'vaning',
  PLAN: 'plan',
  NUMBERS: 'numbers',
};

export const FLOOR_NUMBER_MODE = {
  DEFAULT: 'default',
  FLOOR_NUMBER: 'floorNumber',
  DISPLAY_VALUE: 'displayValue',
};

export const ROW_VERTICAL_ALIGN = {
  TOP: 'flex-start',
  CENTER: 'center',
  BOTTOM: 'flex-end',
} as const;
